import { Configuration } from '@btcdirect/embeddable-loader';
import { computed, reactive, readonly, toRefs } from 'vue';

const config = reactive<Configuration>({
    enableUserIdentifier: false,
    returnUrl: null,
    selector: '.btcdirect-widget',
    theme: 'light',
    useFullWidth: false,
    useSameWindowForPayment: true,
    type: null,
    version: 'v1'
});

export const useConfiguration = () => {
    const set = (configuration: Configuration) => {
        Object.assign(config, configuration);
    };

    const isMyBtcDirect = computed<boolean>(() => window.location.hostname.includes('my.btcdirect.eu'));

    return {
        ...toRefs(readonly(config)),
        keys: Object.keys(config),
        isMyBtcDirect,
        set
    };
};
